import { c as _c } from "react/compiler-runtime";
import { Box, Button, Flex, IconButton, SimpleGrid, Text } from "@chakra-ui/react";
import CloseIcon from "@mui/icons-material/Close";
import { defineMessages, FormattedMessage, useIntl } from "react-intl";
import type { JunctionMovementRow } from "./junctionMovementRows";
export interface JunctionMovementCountsCardProps {
  junctionLabel: string;
  rows: JunctionMovementRow[];
  onMovementSelect: (movementId: number) => void;
  onClose: () => void;
}
const messages = defineMessages({
  subheading: {
    id: "junctionMovementCountsCard.subheading",
    defaultMessage: "Vehicle Counts"
  },
  empty: {
    id: "junctionMovementCountsCard.empty",
    defaultMessage: "No vehicle data"
  },
  pillLabel: {
    id: "junctionMovementCountsCard.pillLabel",
    defaultMessage: "Movement from {entry} to {exit}"
  },
  closeLabel: {
    id: "junctionMovementCountsCard.closeLabel",
    defaultMessage: "Close junction details"
  }
});
const numberFormatter = new Intl.NumberFormat("en-US");
export const JunctionMovementCountsCard = t0 => {
  const $ = _c(19);
  const {
    junctionLabel,
    rows,
    onMovementSelect,
    onClose
  } = t0;
  const intl = useIntl();
  let t1;
  if ($[0] !== junctionLabel) {
    t1 = <Text data-testid="junction-movement-counts-card-title" fontSize="lg" fontWeight="bold" color="text">{junctionLabel}</Text>;
    $[0] = junctionLabel;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== intl) {
    t2 = intl.formatMessage(messages.closeLabel);
    $[2] = intl;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <CloseIcon fontSize="inherit" />;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== onClose || $[6] !== t2) {
    t4 = <IconButton data-testid="junction-movement-counts-card-close" onClick={onClose} size="xs" color="text" aria-label={t2}>{t3}</IconButton>;
    $[5] = onClose;
    $[6] = t2;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t1 || $[9] !== t4) {
    t5 = <Flex align="start" justify="space-between" gap="2">{t1}{t4}</Flex>;
    $[8] = t1;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <Text data-testid="junction-movement-counts-card-subheading" fontSize="xs" color="textMuted" mt="2"><FormattedMessage {...messages.subheading} /></Text>;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== intl || $[13] !== onMovementSelect || $[14] !== rows) {
    t7 = rows.length === 0 ? <Text data-testid="junction-movement-counts-card-empty" mt="2" fontSize="sm" color="textMuted"><FormattedMessage {...messages.empty} /></Text> : <SimpleGrid columns={2} columnGap="6" rowGap="2" mt="2">{rows.map(row => {
        const movementId = row.movement.id;
        const entryLabel = row.movement.entryGate.label;
        const exitLabel = row.movement.exitGate.label;
        return <Flex key={movementId} data-testid={`junction-movement-counts-card-row-${movementId}`} borderTopWidth="1px" borderTopColor="border" pt="1" pb="3" align="start" justify="space-between" gap="2"><Button data-testid={`junction-movement-counts-card-pill-${movementId}`} onClick={() => onMovementSelect(movementId)} bg={row.color} borderRadius="pill" px="2" py="1" height="auto" width="16" fontSize="2xs" fontWeight="bold" color="white" aria-label={intl.formatMessage(messages.pillLabel, {
            entry: entryLabel,
            exit: exitLabel
          })}>{entryLabel} › {exitLabel}</Button><Text data-testid={`junction-movement-counts-card-count-${movementId}`} fontSize="2xl" fontWeight="bold" lineHeight="1" color="text">{numberFormatter.format(row.total)}</Text></Flex>;
      })}</SimpleGrid>;
    $[12] = intl;
    $[13] = onMovementSelect;
    $[14] = rows;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== t5 || $[17] !== t7) {
    t8 = <Box data-testid="junction-movement-counts-card" bg="cardBg" borderRadius="card" boxShadow="elevated" p="6" width="xs">{t5}{t6}{t7}</Box>;
    $[16] = t5;
    $[17] = t7;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  return t8;
};